<template>
<div class="uncertainty-wrapper">
  <div class="data-display-wrapper">
    <div>
      <el-table
        ref="table"
        :data="(data || {statData: []}).statData"
        height="100%"
        border
        stripe
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table no-inner-border"
        style="width: 100%"
        @row-click="factorIdChange"
      >
        <el-table-column prop="name" label="因子" fixed>
          <template slot-scope="{row}">{{factorMap[row.factorId].name}}</template>
        </el-table-column>

        <el-table-column prop="cat" label="影响强度" align="center">
          <template slot-scope="{row}"><span :cat-type="row.cat" class="data-cat" @click="onCatTypeClick(row)"></span></template>
        </el-table-column>

        <el-table-column prop="sn" label="信噪比" align="center">
          <template slot-scope="{row}">{{row.sn === null ? '--' : row.sn.toFixed(1)}}</template>
        </el-table-column>
        <el-table-column prop="min" label="最小值" align="center">
          <template slot-scope="{row}">{{row.min === null ? '--' : row.min.toFixed(5)}}</template>
        </el-table-column>
<!--        <el-table-column prop="p25" label="25%" align="center">-->
<!--          <template slot-scope="{row}">{{row.p25 === null ? '&#45;&#45;' : row.p25.toFixed(5)}}</template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="p50" label="50%" align="center">-->
<!--          <template slot-scope="{row}">{{row.p50 === null ? '&#45;&#45;' : row.p50.toFixed(5)}}</template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="p75" label="75%" align="center">-->
<!--          <template slot-scope="{row}">{{row.p75 === null ? '&#45;&#45;' : row.p75.toFixed(5)}}</template>-->
<!--        </el-table-column>-->
        <el-table-column prop="max" label="最大值" align="center">
          <template slot-scope="{row}">{{row.max === null ? '--' : row.max.toFixed(5)}}</template>
        </el-table-column>
<!--        <el-table-column prop="modeledSamples" label="高大湿说未知" />-->
<!--        <el-table-column prop="rawSamples" label="高大湿说未知" />-->
      </el-table>
    </div>

    <div class="scatter-plot-chart">
      <e-chart ref="chart" />
    </div>
  </div>
</div>
</template>

<script>
import BasePreAnalysis from './BasePreAnalysis'
import EChart from '../../../../../../components/Charts/ECharts'

export default {
  name: 'Uncertainty',
  label: '浓度/不确定度',
  dataKey: 'Uncertainty',
  extends: BasePreAnalysis,
  components: {EChart},
  methods: {
    ready () {
      const {data: {factorId, statData}} = this
      const row = statData.find(data => data.factorId === factorId)

      if (row) {
        this.$refs.table.setCurrentRow(row)
      }

      this.compareStatDataJSONStr = JSON.stringify(statData)
      this.renderChart(factorId)
    },
    getDefaultData () {
      return new Promise((resolve, reject) => {
        this.changeLoadStatus(true)

        this.$api.PMFAnalysis.stat({
          id: this.taskId
        }).then(data => {
          const dataMap = data.reduce((map, data) => {
            map[data.factorId] = data
            return map
          }, {})

          const {factorIds} = this.condition
          const returnData = {
            factorId: factorIds.find(factorId => dataMap[factorId]) || factorIds[0],
            statData: factorIds.map(factorId => dataMap[factorId] || {
              factorId,
              cat: null,
              sn: null,
              min: null,
              p25: null,
              p50: null,
              p75: null,
              max: null,
              modeledSamples: '--',
              rawSamples: '--'
            })
          }

          resolve(returnData)
        }).catch(reject).finally(() => {
          this.changeLoadStatus(false)
        })
      })
    },
    factorIdChange (row) {
      const {data} = this
      const {factorId} = row

      if (data.factorId !== factorId) {
        data.factorId = factorId
        this.renderChart(factorId)
      }
    },
    onCatTypeClick (row) {
      let {cat} = row

      if (cat === null) {
        return
      }

      cat = (cat + 1) % 3

      this.changeLoadStatus(true)
      this.$api.PMFAnalysis.updateCat({
        id: this.taskId,
        factorId: row.factorId,
        cat
      }).then(() => {
        row.cat = cat
        this.$emit('change', this.compareStatDataJSONStr !== JSON.stringify(this.data.statData))
      }).catch(console.error).finally(() => {
        row = cat = null
        this.changeLoadStatus(false)
      })
    },
    renderChart (factorId) {
      const factorData = this.shareData[factorId]
      const factor = this.factorMap[factorId]
      const {dataTimeFormatter} = this
      const chartOpt = {
        title: {
          text: factor.name,
          top: 20,
          left: 'center'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          appendToBody: true,
          formatter: ({data}) => `<div style="display:grid;grid-template-columns:repeat(2, max-content;)grid-column-gap:1em;"><div style="grid-column:1/3;">${data[2]}</div><label>浓度:</label><span style="text-align:right;">${data[0] === null ? '--' : data[0]}μg/m3</span><label>不确定度:</label><span style="text-align:right;">${data[1] === null ? '--' : data[1]}</span></div>`
        },
        grid: {
          top: 70,
          right: 70,
          bottom: 40,
          left: 70,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          name: `浓度(μg/m3)`,
          nameLocation: 'center',
          nameGap: 25,
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false
          },
          axisLabel: {
            formatter: value => Number(value.toFixed(1))
          },
          scale: true
        },
        yAxis: {
          type: 'value',
          name: `不确定度`,
          nameLocation: 'center',
          nameGap: 45,
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false
          },
          axisLabel: {
            formatter: value => Number(value.toFixed(1))
          },
          scale: true
        },
        series: [{
          name: '浓度 VS 不确定度',
          type: 'scatter',
          data: Object.values(factorData).map(data => [data.conc, data.unc, data.dataTime.format(dataTimeFormatter)])
        }]
      }

      this.$refs.chart.setOpt(chartOpt, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.uncertainty-wrapper {
  display: grid;
  grid-template-rows: auto max-content;
  grid-column-gap: 12px;
  padding-top: 12px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .data-display-wrapper {
    display: grid;
    grid-template-columns: minmax(400px, 40%) auto;
    grid-column-gap: 12px;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }
  }
}

.data-cat {
  padding: 3px 5px;

  &:before {
    content: "--";
  }

  &[cat-type="0"] {
    background-color: #b2ffbd;

    &:before {
      content: "强";
    }
  }

  &[cat-type="1"] {
    background-color: #ffb97b;

    &:before {
      content: "弱";
    }
  }

  &[cat-type="2"] {
    background-color: #ffbabb;

    &:before {
      content: "坏";
    }
  }
}

.scatter-plot-chart {
  border: 1px solid #EBEEF5;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/preAnalysisComponents/01Uncertainty.vue